module.exports = __webpack_public_path__ + "static/media/thumb.cfa2ab54.svg";